/* eslint-disable quote-props */
export default {

  // COMMOM
  'yes': 'Sim',
  'no': 'Não',
  'tip': 'Dica',
  'there-are': 'Existem',
  'there-is': 'Existe',
  'read-more': 'Continue lendo',
  'company': 'Empresa',
  'disabled': 'Desabilitado',
  'soon': 'Em breve',
  'in': 'Em',
  'by': 'por',
  'of': 'de',
  'min-read': 'minuto(s) de leitura',
  'no-articles': 'Nenhum artigo disponível',
  'no-questions': 'Nenhuma questão disponível',
  'no-tracks': 'Nenhuma trilha disponível',
  'department': 'Departamento',
  'tags': 'Tags',
  'title': 'Título',
  'content': 'Conteúdo',
  'update': 'Atualizar',
  'updated': 'Atualizado(a)',
  'save': 'Salvar',
  'cancel': 'Cancelar',
  'confirm': 'Confirmar',
  'edit': 'Editar',
  'delete': 'Excluir',
  'unblock': 'Desbloquear',
  'block': 'Bloquear',
  'blocked': 'bloqueado(a)',
  'users': 'Usuários',
  'user': 'Usuário',
  'new-article': 'Novo artigo',
  'article': 'Artigo',
  'articles': 'Artigos',
  'tracks': 'Trilhas',
  'track': 'Trilha',
  'questions': 'Questões',
  'question': 'Questão',
  'departments': 'Departamentos',
  'profile': 'Perfil',
  'logout': 'Sair',
  'create': 'Criar',
  'name': 'Nome',
  'actions': 'Ações',
  'description': 'Descrição',
  'follow': 'seguir',
  'unfollow': 'deixar de seguir',
  'followers': 'Seguidores',
  'follower': 'Seguidor',
  'trending-tags': 'Tags populares',
  'followed-tags': 'Tags seguidas',
  'results': 'Resultados',
  'search': 'Pesquisar',
  'search-for-articles-and-more': 'Pesquise por artigos, usuários, trilhas e questões',
  'no-articles-found-for-term': 'Nenhum artigo encontrado com o termo',
  'no-users-found-for-term': 'Nenhum usuário encontrado com o termo',
  'no-tracks-found-for-term': 'Nenhuma trilha encontrado com o termo',
  'no-questions-found-for-term': 'Nenhuma questão encontrado com o termo',
  'search-articles-placeholder': 'ex.: O que são soft skills?',
  'password': 'Senha',
  'access': 'Acesso',
  'public': 'Público',
  'department-only': 'Departamento',
  'private': 'Privado',
  'click-here': 'Clique aqui',
  'select-city': 'Selecione a cidade',
  'select-state': 'Selecione o estado',
  'select-country': 'Selecione o país',
  'select-access': 'Selecione o acesso',
  'select-department': 'Selecione o departamento',
  'select-language': 'Selecione o idioma',
  'ratings': 'Avaliações',
  'ranking': 'Ranking',

  // INFO / TOOLTIPS
  'some-tracks-may-not-appear-due-to-permission': 'Algumas trilhas podem não aparecer devido ao permissionamento',
  'some-articles-may-not-appear-due-to-permission': 'Alguns artigos podem não aparecer devido ao permissionamento',
  'some-articles-and-questions-are-not-available-due-to-your-permission': 'Alguns artigos e/ou questões não estão disponíveis devido à sua permissão.',
  'your-company-has-no-departments': 'Sua empresa não possui departamentos.',
  'you-are-not-allowed-to-choose-departments': 'Você não possui permissão para escolher departamentos.',
  'your-company-only-have-this-department': 'Sua empresa possui apenas esse departamento.',
  'public-article-access-info': 'Todos da empresa poderão visualizar este artigo.',
  'department-article-access-info': 'Este artigo estará visível apenas para o departamento.',
  'private-article-access-info': 'Apenas você terá acesso à este artigo.',
  'public-track-access-info': 'Todos da empresa poderão visualizar esta trilha.',
  'department-track-access-info': 'Esta trilha estará visível apenas para o departamento.',
  'public-question-access-info': 'Todos da empresa poderão visualizar esta questão.',
  'department-question-access-info': 'Esta questão estará visível apenas para o departamento.',

  // ERRORS
  'sorry': 'Desculpe!',
  'permission-denied': 'Permissão negada',
  'you-dont-have-access-to-this-page-or': 'Você não possui acesso à essa página ou',
  'your-session-has-expired': 'sua sessão expirou.',
  'back-to-login': 'Voltar à tela de login',
  'article-not-found': 'Artigo não encontrado!',
  'we-could-not-find-the-article-you-are-looking-for': 'Não conseguimos encontrar o artigo que você estava procurando.',
  'return-to-page': 'Voltar à página',
  'you-dont-have-permission-to-access-this-article': 'Você não possui permissão para acessar este artigo!',
  'you-dont-have-permission-to-edit-this-article': 'Você não possui permissão para editar este artigo!',
  'you-dont-have-permission-to-create-an-article': 'Você não possui permissão para criar um novo artigo!',
  'you-dont-have-the-right-permission': 'Você não possui a permissão necessária para isso.',
  'the-article-is-personal-or-exclusive-of-a-department-other-than-yours': 'O artigo pode ser pessoal ou exclusivo de um departamento que não o seu.',
  'please-write-a-title-for-your-article': 'Por favor escreva um título para seu artigo.',
  'your-article-should-have-some-content': 'Seu artigo precisa possuir algum conteúdo.',
  'please-choose-a-department-for-your-article': 'Por favor especifíque o departamento em que seu artigo pertencerá.',
  'track-not-found': 'Trilha não encontrada!',
  'you-dont-have-permission-to-edit-this-track': 'Você não possui permissão para editar essa trilha!',
  'you-dont-have-permission-to-edit-this-question': 'Você não possui permissão para editar essa questão!',
  'you-dont-have-permission-to-access-this-track': 'Você não possui permissão para acessar esta trilha!',
  'the-track-is-exclusive-of-a-department-other-than-yours': 'A trilha é exclusiva de um departamento que não o seu.',
  'we-could-not-find-the-track-you-are-looking-for': 'Não conseguimos encontrar a trilha que você estava procurando.',
  'you-cant-create-a-track': 'Você não pode criar uma trilha!',
  'you-cant-create-a-question': 'Você não pode criar uma questão!',
  'you-dont-have-the-right-permission-to-it': 'Você não possui a permissão certa para isso.',
  'you-dont-have-permission-to-access-this-question': 'Você não possui permissão para acessar esta questão!',
  'the-question-was-specifically-directed-to-a-department-other-than-yours': 'A questão foi direcionada especificamente para um departamento que não o seu.',
  'question-not-found': 'Questão não encontrada!',
  'we-could-not-find-the-question-you-are-looking-for': 'Não conseguimos encontrar a questão que você estava procurando.',
  'something-went-wrong': 'Algo deu errado...',
  'please-try-to-reload-page-or-contact-support': 'Por favor, tente recarregar a página ou entre em contato com o suporte.',
  'you-dont-have-permission-to-edit-departments': 'Você não possui permissão para editar departamentos!',
  'email-already-exist': 'O e-mail inserido já existe na base!',
  'company-name-already-exist': 'O nome da empresa já existe na base!',
  'vat-cnpj-already-exist': 'Este CNPJ já existe na base!',
  'please-select-the-company-state': 'Por favor, selecione o "Estado" da empresa!',
  'error-fetching-company-data': 'Erro ao buscar dados da empresa.',
  'error-updating-company': 'Erro ao atualizar os dados da empresa.',
  'you-cant-create-a-user': 'Você não pode criar um usuário!',
  'you-cant-edit-a-user': 'Você não pode editar este usuário!',

  // EDITORJS
  'move-up': 'Mover para cima',
  'move-down': 'Mover para baixo',
  'text': 'Texto',
  'heading': 'Título',
  'list': 'Lista',
  'editor-warning': 'Aviso',
  'checklist': 'Checklist',
  'quote': 'Citar',
  'code': 'Código',
  'delimiter': 'Delimitador',
  'raw-html': 'HTML',
  'table': 'Tabela',
  'marker': 'Marcador',
  'bold': 'Negrito',
  'italic': 'Itálico',
  'inline-code': 'Código embutido',
  'image': 'Imagem',
  'convert-to': 'Converter para',
  'add': 'Adicionar',
  'options': 'Opções',
  'click-to-tune': 'Clique para ajustar',
  'or-drag-to-move': 'or arraste para mover',
  'select-an-image': 'Selecione uma imagem',
  'unordered': 'Não ordenado',
  'ordered': 'Ordenado',
  'add-a-link': 'Adicione um link',
  'with-headings': 'Com título',
  'without-headings': 'Sem título',
  'add-column-to-left': 'Adicionar coluna à esquerda',
  'add-column-to-right': 'Adicionar coluna à direita',
  'delete-column': 'Excluir coluna',
  'add-row-above': 'Adicionar linha acima',
  'add-row-below': 'Adicionar linha abaixo',
  'delete-row': 'Excluir linha',
  'enter-a-code': 'Insira um código',

  // COMPANY SETTINGS
  'settings-of': 'Configurações da',
  'company-settings-info': 'Essa é a página onde você pode editar as informações da empresa.',
  'companys-name': 'Nome da empresa',
  'address': 'Endereço',
  'complement': 'Complemento',
  'enter-the-company-name-placeholder': 'Insira o nome da empresa',
  'enter-the-company-vat-placeholder': 'Insira o CNPJ da empresa',
  'company-country-placeholder': 'ex.: Brasil',
  'company-state-placeholder': 'ex.: Santa Catarina',
  'company-city-placeholder': 'ex.: Balneário Comboriú',
  'company-zip-code-placeholder': 'ex.: 40280900',
  'company-address-placeholder': 'ex.: Rua 292',
  'company-address-2-placeholder': 'ex.: Residencial, Apartamento 202',
  'company-updated': 'Empresa atualizada!',

  // LOGIN | REGISTER
  'please-sign-in': 'Por favor, entrar com os dados de acesso',
  'email-address': 'Endereço de e-mail',
  'sign-in': 'Entrar',
  'dont-have-an-account': 'Não possui uma conta?',
  'register': 'Cadastrar-se',
  'welcome-to-dara': 'Bem-vindo(a) ao Dara',
  'please-enter-your-information': 'Por favor, entre com suas informações',
  'already-have-an-account': 'Já possui uma conta?',
  'login': 'Entrar',
  'company-name': 'Nome da empresa',
  'street-po-box': 'Endereço',
  'building-apartment-floor': 'Residencial, número, andar...',
  'vat-identification-number': 'CNPJ',
  'the-new-password-was-sent-to': 'A nova senha foi enviada para',
  'check-spam-folder': 'Verifique a pasta de spam!',
  'please-type-your-email': 'Por favor, digite seu e-mail',
  'email-not-found': 'E-mail não encontrado!',
  'verify-valid-email': 'O campo "e-mail" deve ser um e-mail válido!',
  'email-or-password-incorrect': 'E-mail e/ou senha incorretos! Por favor, tente novamente.',
  'forgot-password': 'Esqueci minha senha',
  'previous-step': 'Etapa anterior',
  'next-step': 'Próxima etapa',
  'step-1': 'Etapa 1',
  'step-2': 'Etapa 2',
  'user-registration': 'Dados do usuário',
  'company-registration': 'Dados da empresa',
  'this-user-was-blocked': 'Usuário bloqueado!',
  'this-user-was-deleted': 'Usuário excluído!',
  'no-active-user-found': 'Não foram encontrados usuários ativos com este e-mail.',

  // FIELDS
  'first-name-field': '"nome"',
  'last-name-field': '"sobrenome"',
  'email-field': '"e-mail"',
  'password-field': '"senha"',
  'confirm-password-field': '"confirmação de senha"',
  'company-name-field': '"nome da empresa"',
  'country-field': '"país"',
  'state-field': '"estado"',
  'city-field': '"cidade"',
  'zip-code-field': '"código postal"',
  'address-field': '"endereço"',
  'address-complement-field': '"complemento"',
  'vat-field': '"CPNJ"',
  'department-field': '"departamento"',
  'position-field': '"cargo"',
  'description-field': '"descrição"',
  'track-name-field': '"nome da track"',
  'title-field': '"título"',
  'content-field': '"conteúdo"',
  'department-name-field': '"nome do departamento"',
  'phone-field': '"telefone"',
  'birthday-field': '"aniversário"',
  'language-field': '"idioma"',
  'biography-field': '"Biografia"',
  'access-field': '"acesso"',

  // MODAL
  'are-you-sure-you-want-to-delete-this-item': 'Você tem certeza que deseja excluir este item?',
  'change-your-password': 'Altere sua senha',
  'you-should-choose-a-new-password': 'Você deve escolher uma nova senha.',
  'type-your-new-password': 'Digite sua nova senha',
  'confirm-your-new-password': 'Confirme sua nova senha',
  'unable-to-delete-department': 'Não é possível excluir o departamento!',
  'user-associated-with-this-department': 'associado à esse departamento.',
  'users-associated-with-this-department': 'associados à esse departamento.',
  'article-associated-with-this-department': 'associado à esse departamento (podendo esse ser privado).',
  'articles-associated-with-this-department': 'associados à esse departamento (podem haver artigos privados).',
  'question-associated-with-this-department': 'associada à esse departamento.',
  'questions-associated-with-this-department': 'associadas à esse departamento.',
  'track-associated-with-this-department': 'associada à esse departamento.',
  'tracks-associated-with-this-department': 'associadas à esse departamento.',
  'are-you-sure-you-want-to-delete-this-department': 'Você tem certeza que deseja excluir este departamento?',
  'are-you-sure-you-want-to-delete-this-track': 'Você tem certeza que deseja excluir esta trilha?',
  'are-you-sure-you-want-to-delete-this-user': 'Você tem certeza que deseja remover este usuário?',
  'are-you-sure-you-want-to-delete-this-article': 'Você tem certeza que deseja excluir este artigo?',
  'are-you-sure-you-want-to-delete-this-question': 'Você tem certeza que deseja excluir esta questão?',
  'are-you-sure-you-want-to-mark-all-notifications-as-readed': 'Você tem certeza que deseja marcar todas as notificações como lidas?',

  // NOTIFICATIONS
  'no-notifications-left': 'Sem notificações restantes :)',
  'notification-panel': 'Painel de notificações',
  'created-on': 'Criado em',
  'new-article-notification': 'criou um novo artigo!',
  'new-article-from-followed-user': 'criou um novo artigo!',
  'updated-article-notification': 'atualizou um artigo!',
  'you-receive-a-new-answer': 'respondeu sua questão!',
  'new-question-notification': 'criou uma questão!',
  'update-question-notification': 'atualizou uma questão!',
  'new-question-from-followed-user': 'criou uma questão!',
  'update-question-from-followed-user': 'atualizou uma questão!',
  'new-track-notification': 'criou uma trilha!',
  'updated-track-notification': 'atualizou uma trilha!',
  'followed-track-updated': 'Trilha seguida atualizada!',
  'mark-all-as-readed': 'Marcar todas como lidas',
  'a-user': 'Um usuário',
  // 'article-tags-description-notification': 'Novo artigo com tag(s) seguida(s).',
  // 'updated-article-tags-description-notification': 'Artigo atualizado com tag(s) seguida(s).',
  // 'new-article-description-notification': 'Sua empresa possui um novo artigo.',
  // 'updated-article-description-notification': 'Sua empresa possui um artigo atualizado.',
  // 'one-of-your-questions-was-answered': 'Que maravilha! Uma das suas questões foi respondida.',
  // 'question-tags-description-notification': 'Nova questão com tag(s) seguida(s).',
  // 'update-question-tags-description-notification': 'Questão atualizada com tag(s) seguida(s).',
  // 'a-user-has-a-question-try-to-help': 'Um usuário possui uma dúvida.',
  // 'a-user-update-a-question-try-to-help': 'Um usuário atualizou uma dúvida.',
  // 'the-user-has-a-question-try-to-help': 'O usuário possui uma dúvida.',
  // 'the-user-update-a-question-try-to-help': 'O usuário atualizou uma dúvida.',
  // 'new-track-description-notification': 'Sua empresa possui uma nova trilha.',
  // 'updated-track-description-notification': 'Veja o que mudou!',

  // VIEW TAG
  'tag-articles': 'Artigos com a tag',
  'tag-questions': 'Questões com a tag',
  'search-tag-placeholder': 'Busque por tags (e aperte "enter")',

  // TOASTS
  'important': 'Importante!',
  'error': 'Erro!',
  'success': 'Sucesso!',
  'warning': 'Aviso!',
  'passwords-doesnt-match': 'As senhas não coincidem.',
  'you-need-to-choose-a-new-password': 'Você precisa escolher uma nova senha.',
  'password-too-short': 'Sua senha precisa possuir pelo menos 8 caracteres.',
  'password-must-have-special-chars-and-numbers': 'Sua senha deve possuir números e caracteres especiais.',
  'error-updating-users-password': 'Erro ao atualizar a senha do usuário.',
  'error-on-searching-articles': 'Erro ao pesquisar artigos.',
  'error-on-searching-users': 'Erro ao pesquisar users.',
  'error-on-searching-tracks': 'Erro ao pesquisar trilhas.',
  'error-on-searching-questions': 'Erro ao pesquisar questões.',
  'error-on-fetching-department': 'Erro ao buscar departamento.',
  'we-could-not-delete-your-question-at-this-moment': 'Não foi possível excluir sua pergunta neste momento.',
  'error-getting-users': 'Erro ao obter usuários.',
  'error-removing-notification': 'Erro ao remover notificação',
  'we-could-not-save-your-question-at-this-moment': 'Não foi possível salvar sua pergunta neste momento.',
  'error-on-fetching-question': 'Erro ao buscar a pergunta.',
  'error-on-fetching-answers': 'Erro ao buscar respostas.',
  'error-on-updating-question': 'Erro ao atualizar pergunta.',
  'the-limit-is-one-you-selected': 'O limite é 1, você selecionou ',
  'totally-please-first-remove-the-unwanted-file': ' no total. Primeiro remova o arquivo indesejado.',
  'error-deleting-old-image': 'Erro ao excluir imagem antiga.',
  'error-uploading-new-image': 'Erro ao fazer upload da imagem.',
  'error-on-updating-users-preferences': 'Erro ao atualizar as preferências do usuário.',
  'error-on-updating-users-profile': 'Erro ao atualizar o perfil do usuário',
  'error-getting-articles-from-tag': 'Erro ao obter artigos a partir da tag.',
  'error-getting-questions-from-tag': 'Erro ao obter perguntas a partir da tag.',
  'error-getting-tag-user-relation': 'Erro ao obter relação tag/usuário.',
  'error-getting-tag': 'Erro ao obter tag.',
  'error-following-tag': 'Erro ao seguir tag.',
  'error-unfollowing-tag': 'Erro ao deixar de seguir a tag.',
  'error-removing-the-question': 'Erro ao remover a pergunta.',
  'error-on-fetching-track': 'Erro ao buscar trilha.',
  'error-getting-articles-from-track': 'Erro ao obter artigos da trilha.',
  'error-on-saving-track': 'Erro ao salvar trilha.',
  'this-article-already-exists-in-the-track': 'Este artigo já existe na trilha!',
  'error-getting-the-following-status': 'Erro ao obter o status "seguindo".',
  'error-getting-track': 'Erro ao obter a trilha.',
  'error-on-following-track': 'Erro ao seguir a trilha.',
  'error-on-unfollowing-track': 'Erro ao deixar de seguir a trilha.',
  'error-on-following-user': 'Erro ao seguir usuário.',
  'error-on-unfollowing-user': 'Erro ao deixar de seguir o usuário.',
  'error-on-getting-user-by-id': 'Erro ao obter usuário por ID.',
  'error-updating-users-profile': 'Erro ao atualizar o perfil do usuário.',
  'error-creating-new-user': 'Erro ao criar um novo usuário.',
  'error-on-importing-users': 'Erro ao importar usuários!',
  'error-on-importing-user-with-no-department': 'Erro na importação! Usuário sem departamento.',
  'error-on-getting-users-articles': 'Erro ao obter os artigos do usuário.',
  'error-on-getting-followers': 'Erro ao obter os seguidores.',
  'users-password-updated': 'Senha do usuário atualizada!',
  'question-removed': 'Questão removida!',
  'user-successfully-saved': 'Usuário salvo com sucesso!',
  'users-successfully-imported': 'Usuários importados com sucesso!',
  'file-with-incorrect-model-data': 'Arquivo com dados incorretos!',
  'file-with-missing-information': 'Arquivo possui usuário com informação incompleta!',
  'inserted-users': 'Usuários inseridos:',
  'email-already-registered': 'E-mails de usuários já cadastrados:',
  'some-emails-already-registered': 'Alguns usuários já haviam sido cadastrados!',
  'it-was-not-possible-to-get-related-article': 'Não foi possível trazer artigo relacionado.',
  'it-was-not-possible-to-get-next-article': 'Não foi possível trazer o próximo artigo.',
  'there-is-a-article-from-another-department-in-the-track': 'Há um artigo de outro departamento na trilha.',
  'there-is-a-non-public-article-in-the-track': 'Há um artigo não público na trilha.',
  'there-is-a-personal-article-in-the-track': 'Há um artigo pessoal na trilha.',
  'the-article-belong-to-a-track-be-careful-changing-department': 'O artigo pertence a uma track! Cuidado ao alterar o departamento.',
  'the-article-belong-to-a-track-be-careful-changing-access': 'O artigo pertence a uma track! Cuidado ao alterar o acesso.',
  'you-need-to-specify-the-user-department': 'Você precisa especificar o departamento do usuário.',
  'you-need-to-specify-the-department-of-the-imported-users': 'Você precisa especificar o departamento dos usuários importados.',
  'you-need-to-select-a-file': 'Você precisa selecionar um arquivo.',
  'you-need-to-specify-the-track-department': 'Você precisa especificar o departamento da trilha.',
  'you-need-to-specify-the-question-department': 'Você precisa especificar o departamento da questão.',
  'error-verifying-users-associated-with-department': 'Erro ao verificar usuários associados ao departamento.',
  'error-verifying-articles-associated-with-department': 'Erro ao verificar artigos associados ao departamento.',
  'error-verifying-tracks-associated-with-department': 'Erro ao verificar trilhas associados ao departamento.',
  'error-verifying-questions-associated-with-department': 'Erro ao verificar questões associados ao departamento.',
  'error-getting-tracks-department': 'Erro ao buscar departamento da trilha.',
  'error-getting-questions-department': 'Erro ao buscar departamento da questão.',
  'error-getting-department': 'Erro ao buscar departamento.',
  'error-on-saving-article': 'Erro ao salvar artigo.',
  'error-on-saving-department': 'Erro ao salvar departamento.',
  'the-department-description-is-too-long': 'A descrição do departamento é muito longa.',
  'cant-add-user-with-permission-three': 'Não é possível adicionar usuários com permissão 3.',
  'error-marking-question-as-answered': 'Erro ao marcar questão como respondida.',
  'error-getting-best-writer': 'Erro ao obter o melhor escritor.',
  'error-getting-top-writer': 'Erro ao obter o maior escritor.',
  'error-getting-top-reader': 'Erro ao obter o maior leitor.',
  'error-start-date-greater-then-end-date': 'A data inicial deve ser menor que a data final.',

  // VIEW|ADD|EDIT DEPARTMENTS
  'departments-name': 'Nome do departamento',
  'see-all': 'Ver todos os artigos',
  'creating-department': 'Criando um departamento',
  'creating-department-info': 'Escolha o nome e tente descrever em poucas palavras o departamento.',
  'editing-department': 'Editando departamento',
  'editing-department-info1': 'Esta é a página de edição de um departamento.',
  'editing-department-info2': 'Mude o nome do departamento e reescreva a descrição!',
  'department-name-placeholder': 'ex.: Recursos humanos',
  'department-description-placeholder': 'Tente descrever o propósito desse departamento',
  'the-company-already-has-a-department-with-this-name': 'A empresa já possui um departamento com este nome.',
  'to-add-a-new-department': 'para adicionar um novo departamento.',

  // VIEW|ADD QUESTION
  'answer': 'Responder',
  'answers': 'Respostas',
  'no-answers': 'Sem respostas',
  'mark-as-answered': 'Marcar como respondida',
  'total-answers': 'Total de respostas',
  'new-question': 'Nova questão',
  'editing-question': 'Editando uma questão',
  'creating-question-info1': 'Esta é a página onde você pode criar uma questão.',
  'creating-question-info2': 'Sinta-se livre para fazer perguntas relacionadas à seu cargo, tarefas, à empresa...',
  'editing-question-info1': 'Esta é a página onde você pode editar uma questão.',
  'question-title-placeholder': 'ex.: Como fazer...',
  'question-description-placeholder': 'Tente ser o mais descritivo possível (use "#" para inserir tags)',
  'want-to-ask-an-anonymous-question': 'Deseja fazer uma questão anônima?',
  'anonymous-question': 'Questão anônima',

  // VIEW|ADD|EDIT TRACK
  'tracks-name': 'Nome da track',
  'reading-time': 'Tempo de leitura',
  'number-of-articles': 'Número de artigos',
  'new-track': 'Nova trilha',
  'creating-track-info1': 'Esta é a página de criação de uma nova trilha.',
  'creating-track-info2': 'Escolha um nome, escreva uma descrição e adicione artigos!',
  'editing-track': 'Editando trilha',
  'editing-track-info1': 'Esta é a página de edição de uma trilha.',
  'editing-track-info2': 'Adicione ou remova artigos, mude o nome da sua trilha e muito mais!',
  'order': 'Ordem',
  'selected-article': 'Artigo selecionado',
  'searched-article': 'Artigo pesquisado',
  'track-name-placeholder': 'ex.: Conhecimentos gerais',
  'track-description-placeholder': 'Tente descrever o propósito dessa trilha',
  'choose-articles-for-the-track': 'Escolha artigos para a trilha',
  'chosen-articles': 'Artigos escolhidos',
  'set-the-reading-order-of-articles': 'Defina a ordem de leitura dos artigos',
  'created-by': 'Criado por',
  'next-track-article': 'Próximo artigo da trilha',
  'track-end': 'Fim da trilha!',

  // VIEW|ADD|EDIT USER
  'your-profile': '(Seu perfil)',
  'total-articles': 'Artigos escritos:',
  'total-questions': 'Questões feitas:',
  'joined': 'Ingressou',
  'not-specified': '(não especificado)',
  'user-articles': 'Artigos do usuário',
  'user-has-no-articles': '( o usuário não possui artigos )',
  'editing-user': 'Editando:',
  'permission': 'Permissão',
  'reader': 'Leitor(a)',
  'writer': 'Escritor(a)',
  'super-user': 'Super Usuário(a)',
  'admin': 'Admin',
  'ceo': 'CEO',
  'import-users': 'Importar usuários',
  'download-csv-model': 'Baixar arquivo CSV modelo',
  'here': 'aqui',
  'import': 'Importar',
  'best-writer': 'Melhor Escritor',
  'top-writer': 'Maior Escritor',
  'top-reader': 'Maior Leitor',
  'user-first-name-placeholder': 'ex.: Robson',
  'user-last-name-placeholder': 'ex.: da Silva',
  'user-email-placeholder': 'ex.: robson@email.com',
  'user-position-placeholder': 'ex.: Diretor de Marketing',
  'user-zip-code-placeholder': 'ex.: 40280900',
  'user-state-placeholder': 'ex.: Bahia',
  'user-country-placeholder': 'ex.: Brazil',
  'user-bio-placeholder': 'Tente se descrever...',
  'the-chosen-department-will-be-associated-to': 'O departamento escolhido será associado à',
  'all-imported-users': 'todos os usuários importados',
  'my-articles': 'Meus artigos',
  'my-questions': 'Minhas questões',
  'my-tracks': 'Minhas trilhas',
  'users-articles': 'Artigos do usuário',
  'users-questions': 'Questões do usuários',
  'users-tracks': 'Trilhas do usuário',
  'no-followed-users': 'Nenhum usuário seguido',
  'no-followed-tracks': 'Nenhuma trilha seguida',
  'followed-users': 'Usuários seguidos',
  'followed-tracks': 'Trilhas seguidas',

  // VIEW|ADD|EDIT ARTICLE
  'how-to-write-good-article': 'Como escrever um bom artigo',
  'first-tip': 'Crie um título completo e explicativo',
  'second-tip': 'Inicie com um resumo, uma introdução breve',
  'third-tip': 'Seja claro e escreva sucintamente suas ideias',
  'fourth-tip': 'Adicione imagens ao longo do texto',
  'fifth-tip': 'Use um formato e linguagem apropriados',
  'sixth-tip': 'Posicione palavras-chave estrategicamente',
  'save-and-publish': 'Salvar e Publicar',
  'this-will-be-a-public-article': 'Este será um artigo público!',
  'this-will-be-a-department-only-article': 'Este artigo será exclusivo para o departamento!',
  'article-tags-info1': 'Use "#" para inserir tags no texto.',
  'article-tags-info2': 'Isso facilitará a busca pelo seu artigo.',
  'rate-this-article': 'Avalie este artigo',
  'enter-title-here': 'Digite o título aqui...',

  // MY-SPACE
  'write-article': 'Escrever artigo',
  'last-update': 'Última atualização',
  'add-user': 'Adicionar usuário(s)',
  'add-track': 'Criar trilha',
  'add-question': 'Criar questão',
  'answered': 'Respondida',
  'add-department': 'Criar departamento',

  // SETTINGS
  'settings-text': 'Essa é a página onde você pode editar suas informações e preferências.',
  'settings': 'Configurações',
  'preferences': 'Preferências',
  'change-profile-image': 'Alterar foto de perfil',
  'first-name': 'Nome',
  'last-name': 'Sobrenome',
  'email': 'E-mail',
  'phone': 'Telefone',
  'city': 'Cidade',
  'zip-code': 'Código postal',
  'state': 'Estado',
  'country': 'País',
  'birthday': 'Data de nascimento',
  'position': 'Cargo',
  'gender': 'Gênero',
  'biography': 'Biografia',
  'male': 'Masculino',
  'female': 'Feminino',
  'other': 'Não especificado',
  'language': 'Idioma',
  'change-password': 'Alterar senha',
  'confirm-password': 'Confirmação de senha',
  'drop-file-here-or': 'Solte o arquivo aqui ou',
  'click-to-upload': 'click para enviar uma imagem',
  'jpg-png-files-with-size-less-than-500kb': 'arquivos jpg/png deve possuir um tamanho menor que 500kb',

  // PREFERENCES
  'articles-notifications': 'Notificações de artigos:',
  'new-articles-from-followed-users': 'Novos artigos de usuários seguidos',
  'new-articles': 'Novos artigos',
  'updated-articles': 'Artigos atualizados',
  'questions-notifications': 'Notificações de questões:',
  'new-questions-from-followed-users': 'Novas questões de usuários seguidos',
  'new-questions': 'Novas questões',
  'answers-notifications': 'Notificações de respostas:',
  'new-answers': 'Novas respostas',
  'tracks-notifications': 'Notificações de trilhas:',
  'new-tracks': 'Novas trilhas',
  'updated-tracks': 'Trilhas atualizadas',
  'followed-tracks-updated': 'Trilhas seguidas atualizadas',
  'tags-notifications': 'Notificações de tags:',
  'new-or-updated-articles-with-followed-tags': 'Criação ou atualização de artigos com tags seguidas',
  'new-questions-with-followed-tags': 'Novas questões com tags seguidas',
  'email-notifications': 'Notificações de e-mail:',
  'receive-flagged-notifications-by-email': 'Receber notificações por e-mail',
  'receive-featured-articles-by-email': 'Receber artigos em destaque por e-mail',
  'receive-featured-questions-by-email': 'Receber questões em destaque por e-mail',

  // HOME
  'featured-users': 'Usuários em destaque',
  'empty-featured-users': 'aqui aparecerão os usuários em destaque',
  'you': 'você',
  'you-caps': 'Você',
  'empty-trending-tags': 'aqui aparecerão as tags mais utilizadas',
  'empty-followed-tags': 'você não segue nenhuma tag',
  'latest-articles': 'Últimos artigos',
  'latest-tracks': 'Últimas trilhas',
  'latest-questions': 'Últimas questões',

  // TABLES / RANKING PAGE / ANALYTICS
  'avatar': 'Imagem',
  'user-name': 'Nome',
  'total-rating': 'Avaliação Geral',
  'created-articles': 'Artigos Criados',
  'created_articles': 'Artigos Criados',
  'readed-articles': 'Artigos Lidos',
  'readed_articles': 'Artigos Lidos',
  'new-followers': 'Novos Seguidores',
  'current-podium': 'Pódio Atual',
  'referring-to': 'Referente à',
  'ranking-page-description-1': 'Use esta página para acompanhar o Pódio Atual, o Ranking atual, bem como o Ranking por períodos personalizados.',
  'ranking-page-description-2': 'Use a caixa de seleção de mês/ano acima da tabela de ranking para filtrar sua pesquisa.',
  'best-writer-description': 'Artigos mais bem avaliados no mês.',
  'top-writer-description': 'Maior número de artigos no mês.',
  'top-reader-description': 'Maior número de leituras no mês.',
  'to': 'Até:',
  'from': 'De:',
  'user-ranking': 'Ranking de Usuários',
  'begin-date': 'Begin date',
  'end-date': 'End date',
  'there-is-no-best-writer-yet': 'Ainda não temos um Melhor Escritor.',
  'there-is-no-top-writer-yet': 'Ainda não temos um Maior Escritor.',
  'there-is-no-top-reader-yet': 'Ainda não temos um Maior Leitor.',
  'download-csv': 'Baixar CSV',
  'analytics': 'Análise',
  'analytics-description-page': 'Esta é a página onde você pode ver todas as análises da empresa.',
  'answered-questions': 'Questões Respondidas',
  'top-tags': 'Top tags',
  'users-analytics': 'Usuários',
  'articles-analytics': 'Artigos',
  'questions-analytics': 'Questões',
  'tracks-analytics': 'Trilhas',
  'answered-plural': 'Respondida(s)',
  'unanswered-plural': 'Não Respondida(s)',
  'unanswered': 'Não Respondida',
  'all-period': 'Todo período',
  'empty-users-table': 'Sem usuários para os filtros escolhidos',
  'empty-articles-table': 'Sem artigos para os filtros escolhidos',
  'empty-questions-table': 'Sem questões para os filtros escolhidos',
  'empty-tracks-table': 'Sem trilhas para os filtros escolhidos',
  'all-departments': 'Todos os Departamentos',
  'filter-tables': 'Filtrar tabelas',
  'analytics-filter-description': 'Você pode filtrar as tabelas por departamentos e/ou por períodos.',
  'no-questions-to-process': 'Não há questões para serem processadas.',
  'no-tags-to-process': 'Não há tags para serem processadas.',

  // CSV Download
  'articles-label': 'QUANTIDADE DE ARTIGOS',
  'questions-label': 'QUANTIDADE DE QUESTÕES',
  'tracks-label': 'QUANTIDADE DE TRILHAS',
  'answered-questions-label': 'QUANTIDADE DE QUESTÕES RESPONDIDAS',
  'unanswered-questions-label': 'QUANTIDADE DE QUESTÕES NÃO RESPONDIDAS',
  'top-tags-label': 'TOP TAGS',
  'users-table-label': 'USUÁRIOS',
  'articles-table-label': 'ARTIGOS',
  'questions-table-label': 'QUESTÕES',
  'tracks-table-label': 'TRILHAS',
  'tag-label': 'Tag',
  'tag-amount-label': 'Quantidade de uso',
  'data-period-label': 'Dados abaixo referentes ao período',
  'to-period': 'à',

  // DATABASE TRANSLATIONS
  'total_rating': 'Avaliação Geral',
  'readings': 'Leituras',
  'visits': 'Visitas',
  'status': 'Status',
  'created_at': 'Criado(a) em',
  'total_answers': 'Respostas',
  'anonymous': 'Anônimo',

  // CALENDAR
  'january': 'Janeiro',
  'february': 'Fevereiro',
  'march': 'Março',
  'april': 'Abril',
  'may': 'Maio',
  'june': 'Junho',
  'july': 'Julho',
  'august': 'Agosto',
  'september': 'Setembro',
  'october': 'Outubro',
  'november': 'Novembro',
  'december': 'Dezembro',

  // COUNTRIES
  'united-states': 'Estados Unidos',
  'canada': 'Canadá',
  'brazil': 'Brasil',
};
